import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core"
import React from "react";
import CloseIcon from '@material-ui/icons/Close';


export const HailTestView = ({ procedureData }: { procedureData: any }) => {

    const isV12HailTTF =
        procedureData?.tsd_version === "v12" &&
        procedureData?.procedure_definition_name === "Hail Strike Event v12";

    const [open, setOpen] = React.useState(false);

    const baseMarkers = [
        { label: 1, top: "94%", left: "100%" },
        { label: 2, top: "94%", left: "0%" },
        { label: 3, top: "45%", left: "0%" },
        { label: 4, top: "88%", left: "50%" },
        { label: 5, top: "50%", left: "50%" },
        { label: 6, top: "14%", left: "50%" },
    ];

    const entryLength = Math.min(
        procedureData?.hail_test?.entries?.length || 0,
        6 // safety limit
    );

    const markers = baseMarkers.slice(0, entryLength);


    const handleClose = () => {
        setOpen(!open);
    };
    return (
        <div>
            <Typography variant="body1">
                Ambient humidity :{procedureData?.hail_test?.ambient_humidity ? `${procedureData.hail_test.ambient_humidity} %RH` : "N/A"}
            </Typography>
            <Typography variant="body1">
                Ambient temperature :{procedureData?.hail_test?.ambient_temperature ? `${procedureData.hail_test.ambient_temperature} °C` : "N/A"}
            </Typography>
            <Typography variant="body1">
                Equipment Calibration Date :{procedureData?.hail_test?.equipment_calibration_date ? procedureData.hail_test.equipment_calibration_date.substring(0, 10) : "N/A"}
            </Typography>
            <Typography variant="body1">
                HailTest Specs :{procedureData?.hail_test?.hailtest_specs ? `${procedureData.hail_test.hailtest_specs} mm` : "N/A"}
            </Typography>
            <Typography variant="body1">
                Mounting Method :{procedureData?.hail_test?.mounting_method ? procedureData.hail_test.mounting_method : "N/A"}
            </Typography>
            <Typography variant="body1">
                Mounting Tilt :{procedureData?.hail_test?.mounting_tilt ? `${procedureData.hail_test.mounting_tilt} °` : " 0°"}
            </Typography>

            <Button
                variant="contained"
                color="primary"
                onClick={handleClose}
            >
                Impact Data
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={false}>
                <DialogTitle id="id">
                    <div>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1} >{"Impact Data"}</Box>
                            <Box>
                                <IconButton onClick={handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>

                    </div>
                </DialogTitle>
                <DialogContent>
                    <Divider variant="fullWidth" />
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Shot Position</b></TableCell>
                                    <TableCell><b>Diameter (mm)</b></TableCell>
                                    <TableCell><b>Mass (g)</b></TableCell>
                                    <TableCell><b>Speed (m/s)</b></TableCell>
                                    <TableCell><b>Impact Energy (J)</b></TableCell>
                                    <TableCell><b>Result</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {procedureData?.hail_test?.entries?.map((data: any, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell>{data.shot_position}</TableCell>
                                        <TableCell>{data.iceball_diameter}</TableCell>
                                        <TableCell>{data.iceball_mass}</TableCell>
                                        <TableCell>{data.iceball_speed}</TableCell>
                                        <TableCell>{data.impact_energy}</TableCell>
                                        <TableCell>{data.result}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {(isV12HailTTF &&
                        <Box mt={4} display="flex" justifyContent="center">
                            <Box
                                position="relative"
                                width={400}
                                height={220}
                                style={{
                                    backgroundColor: "#1f5f78",
                                    borderRadius: 4,
                                }}
                            >
                                {markers.map((item, index) => (
                                    <Box
                                        key={index}
                                        position="absolute"
                                        style={{
                                            top: item.top,
                                            left: item.left,
                                            transform: "translate(-50%, -50%)",
                                            width: 40,
                                            height: 40,
                                            borderRadius: "50%",
                                            backgroundColor: "black",
                                            color: "white",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {item.label}
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}


                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={handleClose}
                    >
                        CLOSE
                    </Button>

                </DialogActions>
            </Dialog>

        </div>
    )
}